import consultantDetail from '../../components/partners/consultant_detail'
import { createApp } from 'vue';

if (document.getElementById('consultant-detail-page')) {
    const app = createApp({
        components:{
            consultantDetail
        }
    });
    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#consultant-detail-page');
}